var map = {
	"./recipe_album.png": 5361,
	"./recipe_arch_lintel.png": 7193,
	"./recipe_beam.png": 5739,
	"./recipe_bracket.png": 7933,
	"./recipe_burlap.png": 6424,
	"./recipe_caftan_basic.png": 2988,
	"./recipe_caftan_embroidered.png": 8604,
	"./recipe_caftan_grand.png": 6096,
	"./recipe_clean_scroll.png": 5242,
	"./recipe_door.png": 8759,
	"./recipe_fence_panel.png": 8586,
	"./recipe_foundation_block.png": 275,
	"./recipe_frame.png": 3015,
	"./recipe_handle.png": 2250,
	"./recipe_hinge.png": 8009,
	"./recipe_latch.png": 3635,
	"./recipe_nails.png": 2659,
	"./recipe_roof_bundle.png": 6178,
	"./recipe_roof_bundle_light.png": 6181,
	"./recipe_rope.png": 6590,
	"./recipe_small_frame.png": 9167,
	"./recipe_threshold.png": 4012,
	"./recipe_tile.png": 8620,
	"./recipe_wall_section.png": 3430,
	"./recipe_wall_section_corner.png": 2937,
	"./recipe_wall_section_door.png": 7302,
	"./recipe_wall_section_fence.png": 3930,
	"./recipe_wall_section_window.png": 8241,
	"./recipe_window_regular.png": 1139,
	"./recipe_window_small.png": 6314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3050;